/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "Gešter",
        "-2": "Vorgešter",
        "0": "Hitte",
        "1": "Móre",
        "2": "Ubermóre",
        "future": {
          "one": "i {0} tag",
          "other": "i {0} täg"
        },
        "past": {
          "one": "vor {0} tag",
          "other": "vor {0} täg"
        }
      },
      "day-narrow": {
        "-1": "Gešter",
        "-2": "Vorgešter",
        "0": "Hitte",
        "1": "Móre",
        "2": "Ubermóre",
        "future": {
          "one": "i {0} tag",
          "other": "i {0} täg"
        },
        "past": {
          "one": "vor {0} tag",
          "other": "vor {0} täg"
        }
      },
      "day-short": {
        "-1": "Gešter",
        "-2": "Vorgešter",
        "0": "Hitte",
        "1": "Móre",
        "2": "Ubermóre",
        "future": {
          "one": "i {0} tag",
          "other": "i {0} täg"
        },
        "past": {
          "one": "vor {0} tag",
          "other": "vor {0} täg"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "one": "i {0} stund",
          "other": "i {0} stunde"
        },
        "past": {
          "one": "vor {0} stund",
          "other": "vor {0} stunde"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "one": "i {0} stund",
          "other": "i {0} stunde"
        },
        "past": {
          "one": "vor {0} stund",
          "other": "vor {0} stunde"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "one": "i {0} stund",
          "other": "i {0} stunde"
        },
        "past": {
          "one": "vor {0} stund",
          "other": "vor {0} stunde"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "one": "i {0} minüta",
          "other": "i {0} minüte"
        },
        "past": {
          "one": "vor {0} minüta",
          "other": "vor {0} minüte"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "one": "i {0} minüta",
          "other": "i {0} minüte"
        },
        "past": {
          "one": "vor {0} minüta",
          "other": "vor {0} minüte"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "one": "i {0} minüta",
          "other": "i {0} minüte"
        },
        "past": {
          "one": "vor {0} minüta",
          "other": "vor {0} minüte"
        }
      },
      "month": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "I {0} mánet",
          "other": "I {0} mánet"
        },
        "past": {
          "one": "vor {0} mánet",
          "other": "vor {0} mánet"
        }
      },
      "month-narrow": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "I {0} mánet",
          "other": "I {0} mánet"
        },
        "past": {
          "one": "vor {0} mánet",
          "other": "vor {0} mánet"
        }
      },
      "month-short": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "I {0} mánet",
          "other": "I {0} mánet"
        },
        "past": {
          "one": "vor {0} mánet",
          "other": "vor {0} mánet"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "one": "i {0} sekund",
          "other": "i {0} sekunde"
        },
        "past": {
          "one": "vor {0} sekund",
          "other": "vor {0} sekunde"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "one": "i {0} sekund",
          "other": "i {0} sekunde"
        },
        "past": {
          "one": "vor {0} sekund",
          "other": "vor {0} sekunde"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "one": "i {0} sekund",
          "other": "i {0} sekunde"
        },
        "past": {
          "one": "vor {0} sekund",
          "other": "vor {0} sekunde"
        }
      },
      "week": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "i {0} wuča",
          "other": "i {0} wučä"
        },
        "past": {
          "one": "vor {0} wuča",
          "other": "cor {0} wučä"
        }
      },
      "week-narrow": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "i {0} wuča",
          "other": "i {0} wučä"
        },
        "past": {
          "one": "vor {0} wuča",
          "other": "cor {0} wučä"
        }
      },
      "week-short": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "i {0} wuča",
          "other": "i {0} wučä"
        },
        "past": {
          "one": "vor {0} wuča",
          "other": "cor {0} wučä"
        }
      },
      "year": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "I {0} jár",
          "other": "I {0} jár"
        },
        "past": {
          "one": "vor {0} jár",
          "other": "cor {0} jár"
        }
      },
      "year-narrow": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "I {0} jár",
          "other": "I {0} jár"
        },
        "past": {
          "one": "vor {0} jár",
          "other": "cor {0} jár"
        }
      },
      "year-short": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "I {0} jár",
          "other": "I {0} jár"
        },
        "past": {
          "one": "vor {0} jár",
          "other": "cor {0} jár"
        }
      }
    },
    "locale": "wae"
  });
}